import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconCircleDeleteOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M12 0c6.628 0 12 5.373 12 12s-5.372 12-12 12C5.373 24 0 18.627 0 12S5.373 0 12 0m0 22.5c5.79 0 10.5-4.71 10.5-10.5S17.79 1.5 12 1.5 1.5 6.21 1.5 12 6.21 22.5 12 22.5m3.75-15.31 1.061 1.06-3.75 3.75 3.75 3.75-1.06 1.06L12 13.06l-3.75 3.75-1.062-1.06L10.94 12 7.19 8.25 8.25 7.19 12 10.94z" /></svg>
);
